import React from 'react';
import { Switch, Route } from 'react-router-dom'
import Header from './semantic/header/Header'
import Footer from './semantic/footer/Footer'
import Home from './components/Home';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact'; 
import './styles/App.css';


function App() {
  return (

    <div className="App">

        <div className="header-div">
            <Header headline = "Stucko Plumbo"/>
        </div>

            <Switch>
                    <Route exact path= '/' component= {Home} />
                    <Route path= '/about' component= {About} /> 
                    <Route path= '/services' component= {Services}/> 
                    <Route path= '/contact' component= {Contact} />
            </Switch>

            <Footer/> 

    </div>

  );
}

export default App;
